export enum IconSizesEnum {
  small = 'small',
  medium = 'medium',
  large = 'large',
  x_large = 'x_large',
  huge = 'huge', // currently only used no-items view of a feed
  custom = 'custom',
}
